import React, { Fragment, PureComponent } from 'react'
import i18n from 'i18next'
import * as R from 'ramda'
import Panel from '../../../../../UniformComponents/Panel'
import PanelHeader from '../../../../../UniformComponents/PanelHeader'
import Badge from '../../../../../UniformComponents/Badge'

const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

class XTab extends PureComponent {
    constructor(props) {
        super(props)
    }

    getColumnName = (index) => {
        let c = ''
        let colInt = index
        while (colInt >= 0) {
            c += alphabet[colInt % 26]
            colInt -= 26
        }
        return c
    }

    getAverageSignificance = (colIndex, data) => {
        const { options } = this.props
        const { avg, tTest } = options
        const significance = R.pathOr(false, ['averageSignificance', colIndex])(data)

        if (!(avg && tTest) || !significance) {
            return null
        }

        const overallAverage = R.pathOr(0, ['overallAverage'])(data)
        const average = R.pathOr(0, ['average', colIndex])(data)

        const color = average > overallAverage ? '#16CCC1' : '#D9314B'
        const direction = average > overallAverage ? 'up-right' : 'down-left'

        return (
            <i className={`fa-regular fa-arrow-${direction}`} style={{ color, marginLeft: '10px' }} />
        )
    }

    getChiSquared = (rowIndex, data, xTab) => {
        const { options } = this.props
        const { chiSquare } = options
        const chiSquared = R.pathOr(false, ['chiSquared'])(data)
        const pct = R.pathOr(0, ['pct'])(data)
        const rowPct = R.pathOr(0, ['rowPctOfResp', rowIndex])(xTab)

        if (!chiSquared || !chiSquare) {
            return null
        }

        const color = pct > rowPct ? '#16CCC1' : '#D9314B'
        const direction = pct > rowPct ? 'up-right' : 'down-left'

        return (
            <i className={`fa-regular fa-arrow-${direction}`} style={{ color }} />
        )
    }

    getQuestionTitle = (xtabs, groupId) => {
        const { questionMap, questions } = this.props
        let set1
        let optionLabel
        const { rowQuestion } = xtabs[0]
        const columnTitles = Array.from(new Set(xtabs.map(({ columnQuestion }) => questionMap[columnQuestion]))).join(' VS ')

        if (groupId && groupId.includes('_')) {
            set1 = groupId.split('_')[1]
            const question = questions.find(({ id }) => id === rowQuestion)
            if (question) {
                const option = question.options.find(({ setYId }) => setYId.toUpperCase() === set1)
                optionLabel = option ? option.label.split('-')[0].trim() : ''
            }
        }

        // const [questionId, set1] = id.split('_')
        return `${questionMap[rowQuestion]}${optionLabel ? ` - ${optionLabel}` : ''} VS ${columnTitles}`
    }

    render() {
        const {
            options, reportResult, questionMap, reportquestions, dataLoading,
        } = this.props
        const {
            totalRowPct, totalColumnN, totalRowN, cellN, columnPct, rowPct, avg, zScore, chiSquare, tTest,
        } = options
        return (
            // <div style={{ height: (dataLoading ? '100%' : 'auto'), minWidth: 0 }}>
            <Fragment>
                {dataLoading && <div className="loader" />}
                {Object.values(reportResult).map((xtabs, index) => (
                    <Panel cssClass="question" style={{ minWidth: 0, maxWidth: '100%' }}>
                        {/* <div style={{ marginTop: '10px', overflow: 'auto' }}> */}
                        <PanelHeader>
                            <div
                                style={{
                                    padding: '25px',
                                    background: 'rgb(250, 251, 252)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '15px',
                                }}
                            >
                                <h2 className="reportquestiontitle">
                                    <i className="far fa-th" style={{ marginRight: '5px' }} />
                                    {`${this.getQuestionTitle(xtabs, xtabs[0].groupId)}`}
                                </h2>
                            </div>
                        </PanelHeader>
                        <div style={{ overflow: 'auto', maxWidth: '100%', minWidth: 0 }}>
                            <table className="datatable">
                                <thead>
                                    <tr className="col">
                                        <th style={{ textAlign: 'left', paddingLeft: '16px' }}>Option Name</th>
                                        {xtabs.map((xtab) => (
                                            <Fragment>
                                                {xtab.xOptions.map(({ label }) => (
                                                    <th style={{ textAlign: 'center' }}>{label}</th>
                                                ))}
                                                {(totalRowN || totalRowPct) && (<th style={{ textAlign: 'center' }}>Total</th>)}
                                            </Fragment>
                                        ))}
                                        <td className="tlast" />
                                    </tr>
                                </thead>
                                <tbody>
                                    {xtabs[0].yLabels.map((label, rowIndex) => (
                                        <tr className="col">
                                            <th>{label}</th>
                                            {xtabs.map((xtab) => (
                                                <Fragment>
                                                    {xtab.xOptions.map(({ responses, count }, colIndex) => (
                                                        <td style={{ textAlign: 'center' }}>
                                                            <div>
                                                                {columnPct && (
                                                                    <div>
                                                                        {`${responses[rowIndex].pct.toFixed(2)}%`}
                                                                    </div>
                                                                )}
                                                                {chiSquare && (
                                                                    <div>
                                                                        {this.getChiSquared(rowIndex, responses[rowIndex], xtab)}
                                                                    </div>
                                                                )}
                                                                {rowPct && (
                                                                    <div>
                                                                        {`${responses[rowIndex].rowPct.toFixed(2)}%`}
                                                                    </div>
                                                                )}
                                                                {cellN && (
                                                                    <div>
                                                                        {responses[rowIndex].numberOfResponses}
                                                                    </div>
                                                                )}
                                                                {zScore && (
                                                                    <div>
                                                                        {(R.pathOr([], [rowIndex, 'zScore'])(responses).join(','))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                    ))}
                                                    {(totalRowPct || totalRowN) && (
                                                        <td style={{ textAlign: 'center' }}>
                                                            <div>
                                                                {totalRowPct && (
                                                                    <div>
                                                                        {`${R.pathOr(0, ['rowPctOfResp', rowIndex])(xtab).toFixed(2)}%`}
                                                                    </div>
                                                                )}
                                                                {totalRowN && (
                                                                    <div>
                                                                        {xtab.count[rowIndex]}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                    )}
                                                </Fragment>
                                            ))}
                                            <td className="tlast" />
                                        </tr>
                                    ))}
                                    {(zScore) && (
                                        <tr>
                                            <th>Column Name</th>
                                            {xtabs.map((xtab) => (
                                                <Fragment>
                                                    {xtab.xOptions.map(({ count }, colIndex) => (
                                                        <td style={{ textAlign: 'center' }}>
                                                            <div>
                                                                {this.getColumnName(colIndex)}
                                                            </div>
                                                        </td>
                                                    ))}
                                                    {(totalRowN || totalRowPct) && (<td style={{ textAlign: 'center' }} />)}
                                                </Fragment>
                                            ))}
                                            <td className="tlast" />
                                        </tr>
                                    )}
                                    {(totalColumnN) && (
                                        <tr>
                                            <th>Total</th>
                                            {xtabs.map((xtab) => (
                                                <Fragment>
                                                    {xtab.xOptions.map(({ count }, colIndex) => (
                                                        <td style={{ textAlign: 'center' }}>
                                                            {totalColumnN && (
                                                                <div>
                                                                    {count}
                                                                </div>
                                                            )}
                                                        </td>
                                                    ))}
                                                    {(totalRowN || totalRowPct) && (
                                                        <td style={{ textAlign: 'center' }}>
                                                            <div>
                                                                {xtab.totalNumberOfResp}
                                                            </div>
                                                        </td>
                                                    )}
                                                </Fragment>
                                            ))}
                                            <td className="tlast" />
                                        </tr>
                                    )}
                                    {(avg && xtabs.some((xtab) => R.hasPath(['average'])(xtab))) && (
                                        <tr>
                                            <th>{xtabs[0].isNPS ? i18n.t('report_net_promoter_score') : 'Average'}</th>
                                            {xtabs.map((xtab) => (
                                                <Fragment>
                                                    {xtab.xOptions.map((o, colIndex) => (
                                                        <td style={{ textAlign: 'center' }}>
                                                            <div>
                                                                {xtab.average[colIndex].toFixed(2)}
                                                            </div>
                                                            {tTest && (
                                                                <div>
                                                                    {this.getAverageSignificance(colIndex, xtab)}
                                                                </div>
                                                            )}
                                                        </td>
                                                    ))}
                                                    {(totalRowN || totalRowPct) && (
                                                        <td style={{ textAlign: 'center' }}>
                                                            {avg && (
                                                                <div>
                                                                    {R.pathOr(0, ['overallAverage'])(xtab).toFixed(2)}
                                                                </div>
                                                            )}
                                                        </td>
                                                    )}
                                                </Fragment>
                                            ))}
                                            <td className="tlast" />
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {/* </div> */}
                    </Panel>
                ))}
                {/* </div> */}
            </Fragment>
        )
    }
}

export default XTab
